import React from 'react'
import { Controller } from 'react-hook-form'

import { runSsnValidation } from '../../../../utils/validators'
import { patientFormErrors } from '../../_errors'
import PatientFormField from '../PatientFormField'
import { FormatedPatientFormData } from '../_props'
import { insNumMinLength, useFormContextPatient } from '../_utils'

const PatientIsSameAsInsured = () => {
    const { control, resetField, clearErrors } = useFormContextPatient()

    const handleFieldReset = React.useCallback(
        (fieldKey: keyof FormatedPatientFormData) => {
            resetField(fieldKey, {
                defaultValue: '',
            })
            clearErrors(fieldKey)
        },
        [clearErrors, resetField],
    )

    return (
        <Controller
            control={control}
            name="patientIsSameAsInsured"
            render={({ field, fieldState: { error } }) => {
                const checked = field.value ?? false

                return (
                    <>
                        <PatientFormField
                            variant="switch"
                            label="Le patient est-il l’assuré ?"
                            name={field.name}
                            status={{
                                error,
                                valid: false,
                            }}
                            required
                            size="1"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    handleFieldReset('insuredSsn')
                                    handleFieldReset('patientInsuredUserLabel')
                                } else {
                                    handleFieldReset('socialSecurityNumber')
                                }
                                field.onChange(e)
                            }}
                            checked={checked}
                            switchLabel={field.value ? 'Oui' : 'Non'}
                        />
                        {!checked && (
                            <>
                                <Controller
                                    control={control}
                                    name="insuredSsn"
                                    rules={{
                                        required: patientFormErrors.insuredSsn?.required,
                                        maxLength: insNumMinLength,
                                        minLength: {
                                            value: insNumMinLength,
                                            message: patientFormErrors.insuredSsn?.minLength ?? '',
                                        },
                                        validate: (val) => {
                                            const validation = () => {
                                                if (val) {
                                                    return runSsnValidation({
                                                        ssn: val,
                                                        sex: 'i',
                                                    })
                                                }

                                                return false
                                            }

                                            return validation()
                                        },
                                    }}
                                    render={({ field: insuredSsnField, fieldState: insuredFieldState }) => (
                                        <PatientFormField
                                            variant="input"
                                            label="Numéro de sécurité sociale de l’assuré (si ayant droit)"
                                            status={{
                                                error: insuredFieldState.error,
                                                valid: Boolean(insuredSsnField.value),
                                            }}
                                            size="0.5"
                                            required
                                            dataCyScope="PatientField"
                                            {...insuredSsnField}
                                            value={insuredSsnField.value ?? undefined}
                                            inputProps={{
                                                maxLength: insNumMinLength,
                                            }}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="patientInsuredUserLabel"
                                    rules={{
                                        required: patientFormErrors.patientInsuredUserLabel?.required,
                                        validate: (val) => (val ? val?.trim().length > 0 : false),
                                    }}
                                    render={({ field: insuredUserLabelField, fieldState: insuredFieldState }) => (
                                        <PatientFormField
                                            variant="input"
                                            label="Nom et prénom de l'assuré(e)"
                                            status={{
                                                error: insuredFieldState.error,
                                                valid: Boolean(insuredUserLabelField.value),
                                            }}
                                            dataCyScope="PatientField"
                                            size="0.5"
                                            required
                                            {...insuredUserLabelField}
                                            value={insuredUserLabelField.value ?? undefined}
                                        />
                                    )}
                                />
                            </>
                        )}
                    </>
                )
            }}
        />
    )
}

export default PatientIsSameAsInsured
